import React from "react"
import styles from "./styles.scss"
import { Async, components } from "react-select"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { getSearchResults, selectSearch } from "data/search"
import { connect } from "react-redux"

const groupStyles = {
  display: "flex",
  alignItems: "center",
  fontSize: 14,
  justifyContent: "space-between",
}
const groupBadgeStyles = {
  backgroundColor: "#EBECF0",
  borderRadius: "2px",
  color: "#172B4D",
  display: "inline-block",
  fontSize: 12,
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.16666666666667em 0.5em",
  textAlign: "center",
}

const formatGroupLabel = data => (
  <div style={groupStyles}>
    <span>{data.label === "categories" ? "Kategorier" : "Företag"}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
)
const inputStyle = {
  control: (styles, { isDisabled }) => ({
    ...styles,
    height: "50px",
    borderRadius: "0 2px 2px 0",
    border: "0px",
    backgroundColor: isDisabled ? "#E8E8E8" : "#ffffff",
    cursor: "text",
  }),
  indicatorSeparator: styles => ({}),
  dropdownIndicator: styles => ({ ...styles, marginRight: "12px" }),
  valueContainer: styles => ({ ...styles, marginLeft: "12px" }),
}

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <FontAwesomeIcon icon="search" />
      </components.DropdownIndicator>
    )
  )
}

class SearchField extends React.Component {
  getOptions = async input => {
    const county = JSON.parse(localStorage.getItem("County"))
    if (county) {
      await this.props.getSearchResults(county.id, input)
      const { searchResults } = this.props

      const formatted = Object.keys(searchResults).map(options => ({
        label: options,
        options: searchResults[options].map(item => ({
          label: item.name,
          value: item.id,
          type: options,
        })),
      }))

      return formatted
    }
  }

  handleChange = value => {
    this.props.onSearch(value)
  }

  render() {
    return (
      <div className={styles.container}>
        <Async
          isDisabled={this.props.countyIsSet}
          noOptionsMessage={() => null}
          components={{ DropdownIndicator }}
          styles={inputStyle}
          formatGroupLabel={formatGroupLabel}
          loadOptions={this.getOptions}
          placeholder={this.props.placeholder}
          onChange={this.handleChange}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  searchResults: selectSearch(state, ownProps),
})

export default connect(mapStateToProps, {
  getSearchResults,
})(SearchField)



// WEBPACK FOOTER //
// src/components/SearchBarWrapper/SearchField/index.jsx